"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const SEASONS_DROPDOWN_QUERY = (0, client_1.gql) `
  query seasonsDropdown($query: SeasonQueryInput) {
    seasons(query: $query) {
      _id
      name
      published
      venueId
      seatingChartKey
      schedule {
        startsAt
        endsAt
      }
    }
  }
`;
exports.default = SEASONS_DROPDOWN_QUERY;
//# sourceMappingURL=seasonsDropdown.query.js.map